import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

// @mui material components
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Fab from "@mui/material/Fab";
import { useTheme, useMediaQuery } from "@mui/material";

// Argon components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

function ChatPopout({ defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleToggle = () => {
    setOpen(!open);
  };

  const handleFullChat = () => {
    navigate('/chat');
    setOpen(false);
  };

  // Don't render on mobile as mobile navigation handles it
  if (isMobile) {
    return null;
  }

  return (
    <>
      {/* Floating Chat Button */}
      <Fab
        color="primary"
        aria-label="chat"
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: 1200,
        }}
        onClick={handleToggle}
      >
        <Icon>chat</Icon>
      </Fab>

      {/* Chat Drawer */}
      <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: 320,
            boxSizing: "border-box",
            backgroundColor: "background.paper",
            borderLeft: "1px solid",
            borderColor: "divider",
          },
        }}
      >
        <ArgonBox p={2}>
          <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <ArgonTypography variant="h6">Chat</ArgonTypography>
            <ArgonBox>
              <IconButton size="small" onClick={handleFullChat} sx={{ mr: 1 }}>
                <Icon>open_in_new</Icon>
              </IconButton>
              <IconButton size="small" onClick={() => setOpen(false)}>
                <Icon>close</Icon>
              </IconButton>
            </ArgonBox>
          </ArgonBox>
          
          <ArgonBox
            sx={{
              height: "calc(100vh - 100px)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <Icon sx={{ fontSize: 48, mb: 2 }} color="text">chat_bubble_outline</Icon>
            <ArgonTypography variant="body2" color="text" mb={3}>
              Start a conversation or select a contact
            </ArgonTypography>
            <ArgonTypography
              variant="button"
              color="info"
              sx={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={handleFullChat}
            >
              Open Full Chat
            </ArgonTypography>
          </ArgonBox>
        </ArgonBox>
      </Drawer>
    </>
  );
}

ChatPopout.propTypes = {
  defaultOpen: PropTypes.bool,
};

export default ChatPopout;